import { Component, Input } from '@angular/core';

import { generateUid } from '~/core/helpers/uid/uid.helper';

import { TipsVariantEnum } from './enum/variant.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { CtaButtonTypeEnum } from '../call-to-action/enums/button-type.enum';
import { VtmnPlayIconButtonSizeEnum } from '../buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '../buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss'],
})
export class TipsComponent {
  @Input() public displayArrowIcon = true;
  @Input() public icon?: VtmnPlayIconTypeEnum;
  @Input() public skipBullet?: boolean;
  @Input() public tips?: string | string[];
  @Input() public title: string;
  @Input() public variant? = TipsVariantEnum.INFO;

  private readonly id = generateUid();

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly iconType = VtmnPlayIconTypeEnum.Check;
  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;

  public isOpen = true;

  public get arrowIcon(): VtmnPlayIconTypeEnum {
    return this.isOpen
      ? VtmnPlayIconTypeEnum.ChevronUp
      : VtmnPlayIconTypeEnum.ChevronDown;
  }

  public get contentId(): string {
    return `tips-content-${this.id}`;
  }

  public get isTipsArray(): boolean {
    return Array.isArray(this.tips);
  }

  public get variantClass(): string {
    return `tips--${this.variant}`;
  }

  public toggleOpenStatus(): void {
    this.isOpen = !this.isOpen;
  }
}
